import { ShipperCargoListPage } from "@/pages/shipper-cargo-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/shipper/cargos/")({
  component: () => <ShipperCargoListPage />,
});
